var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrop = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 0V3H0V4.5H3V15C3 18.3137 5.68616 21 9 21H19.5V24H21V21H24V19.5H21V9C21 5.68629 18.3138 3 15 3H4.5V0H3ZM15 4.5H4.5V15C4.5 17.4853 6.51489 19.5 9 19.5H19.5V9C19.5 6.51471 17.4851 4.5 15 4.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crop.97971f14dcdb2f7f587fc3b846afe815.svg";